import { useEffect, useState, type ReactNode } from 'react';

const DEFAULT_USER = 'marthe';
const DEFAULT_DOMAIN = 'systemique.nl';

function useJoinedEmail(user: string, domain: string) {
  const [email, setEmail] = useState('');
  useEffect(() => {
    setEmail(`${user}@${domain}`);
  }, [user, domain]);
  return email;
}

export type EmailLinkProps = {
  user?: string;
  domain?: string;
  className?: string;
  children?: ReactNode;
};

/**
 * Mailto link without exposing the full address in static HTML.
 * Uses data-user / data-domain; full address is assembled in useEffect.
 */
export function EmailLink({
  user = DEFAULT_USER,
  domain = DEFAULT_DOMAIN,
  className,
  children,
}: EmailLinkProps) {
  const email = useJoinedEmail(user, domain);

  return (
    <a
      className={className}
      data-user={user}
      data-domain={domain}
      href={email ? `mailto:${email}` : '#'}
      onClick={(e) => {
        if (!email) e.preventDefault();
      }}
    >
      {children ?? email}
    </a>
  );
}

export type EmailTextProps = {
  user?: string;
  domain?: string;
  className?: string;
};

/**
 * Plain-text email (no mailto) with the same obfuscation pattern as EmailLink.
 */
export function EmailText({ user = DEFAULT_USER, domain = DEFAULT_DOMAIN, className }: EmailTextProps) {
  const email = useJoinedEmail(user, domain);

  return (
    <span className={className} data-user={user} data-domain={domain}>
      {email}
    </span>
  );
}
